export default __webpack_public_path__ + "static/media/102t.4dd2b2a0.jpg";